import CustomerIcon from '@mui/icons-material/Group'; // Use appropriate icon

import CustomerList from './CustomerList';
import CustomerEdit from './CustomerEdit';

export default {
    list: CustomerList,
    edit: CustomerEdit,
    icon: CustomerIcon,
};